export var Reports;
(function (Reports) {
    function bindScope(client) {
        return {
            DownloadReport: client.bindCallable({
                name: 'DownloadReport',
                scope: 'reports',
                path: '/api/reports/download-report',
                method: 'post',
                kind: 'api',
            }),
        };
    }
    Reports.bindScope = bindScope;
})(Reports || (Reports = {}));
//# sourceMappingURL=reports.js.map